const Menu = [
  {
    title: 'Product',
    items: [
      {
        label: 'Overview',
        url: '',
      },
      {
        label: 'Pricing',
        url: '',
      },
      {
        label: 'Marketplace',
        url: '',
      },
      {
        label: 'Features',
        url: '',
      },
      {
        label: 'Integrations',
        url: '',
      },
    ]
  },
  {
    title: 'Company',
    items: [
      {
        label: 'About',
        url: '',
      },
      {
        label: 'Team',
        url: '',
      },
      {
        label: 'Blog',
        url: '',
      },
      {
        label: 'Careers',
        url: '',
      },
    ]
  },
  {
    title: 'Contact',
    items: [
      {
        label: 'Contact',
        url: '',
      },
      {
        label: 'Newsletter',
        url: '',
      },
      {
        label: 'LinkedIn',
        url: '',
      },
    ]
  },
]

export default Menu